'use strict';

module.exports = function() {
	this.x1 = this.canvas.offsetWidth;
	this.y1 = this.canvas.offsetHeight;
};



//////////////////
// WEBPACK FOOTER
// ./~/granim/lib/getDimensions.js
// module id = 16
// module chunks = 0